import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ProductDiamondsDirectDifference extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='ProductDiamondsDirectDifference' onClick={() => this.internalNav('our-guarantees')} style={{ cursor: 'pointer' }}>
			<div className='differenceTitle'>The Diamonds Direct Difference</div>
      <div className='differenceBrWrapper'>
        <img src='https://ddw2.diamondsdirect.com/img/productpage/iconline.svg' />
      </div>
      <div className='differencesWrapper'>
        <div className='differenceItem'>
          <div className='differenceIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/upgrade.svg' />
          </div>
          <div className='differenceItemTitle'>110% Lifetime Upgrade</div>
          <div className='differenceText'>Trade in your original engagement diamond, solitaire diamond pendant or diamond studs and get 110% of your original purchase toward your new purchase!</div>
        </div>
        <div className='differenceItem'>
          <div className='differenceIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/warranty.svg' />
          </div>
          <div className='differenceItemTitle'>Lifetime Warranty</div>
          <div className='differenceText'>With every Diamonds Direct purchase you’ll receive lifetime coverage on routine jewelry maintenance.</div>
        </div>
        <div className='differenceItem'>
          <div className='differenceIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/care.svg' />
          </div>
          <div className='differenceItemTitle'>Free Lifetime Jewelry Care</div>
          <div className='differenceText'>Your purchase includes complimentary jewelry care for life, including free cleanings, prong tightening, rhodium plating and more!</div>
        </div>
        <div className='differenceItem'>
          <div className='differenceIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/appraisal.svg' />
          </div>
          <div className='differenceItemTitle'>Certificate &amp; Appraisal</div>
          <div className='differenceText'>All purchases over $1,000 will include an appraisal for insurance purchases. In addition, a GIA certificate will accompany all GIA diamond purchases.</div>
        </div>
        <div className='differenceItem'>
          <div className='differenceIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/shipping.svg' />
          </div>
          <div className='differenceItemTitle'>Free Shipping</div>
          <div className='differenceText'>FREE, secure, insured shipping with FedEx hassle-free returns for 30 days.</div>
        </div>
      </div>
		</div>;
	}
}
export default ProductDiamondsDirectDifference;

function mapStateToProps(state) {
  return {

  };
}

export const ProductDiamondsDirectDifferenceContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductDiamondsDirectDifference);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductDiamondsDirectDifference.jsx